import { Link } from 'react-router-dom'
import { TicketsShell } from '../layout/TicketsShell'
import { usePageMeta } from '../hooks/usePageMeta'
import { schemaGraph, schemaWebPage } from '../lib/schema-org'

export function EventTicketsSuccessPage() {
  usePageMeta({
    title: 'Zahlung erfolgreich',
    description: 'Deine BNKR-Tickets wurden bestätigt.',
    canonical: '/events/tickets/success',
    noindex: true,
    jsonLd: schemaGraph(
      schemaWebPage({
        path: '/events/tickets/success',
        name: 'Zahlung erfolgreich — BNKR Tickets',
        description: 'Ticketkauf bei BNKR erfolgreich abgeschlossen.',
      }),
    ),
  })

  return (
    <TicketsShell backTo="/events">
      <div className="tickets-shell__message">
        <p className="kicker">TICKETS</p>
        <h1>Zahlung erfolgreich</h1>
        <p>Deine Tickets wurden an deine E-Mail-Adresse gesendet.</p>
        <Link to="/events" className="btn-ghost-crt">← Zurück zu Events</Link>
      </div>
    </TicketsShell>
  )
}
